module.exports = __webpack_public_path__ + "media/images/sales/nanairoweek/eyecatch-campaign-1-d0111d58d2f2d2c769ec0ed26a20abbd.svg";